import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import CustomData from "pages/_components/CustomData/CustomData";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { actions as creditBillActions } from "reducers/creditBills";
import * as i18n from "util/i18n";
import BillInfoSummary from "../components/BillsInfoSummary";
import ActionBillTable from "../components/Table";

const TransmitFCEMSummaryPage = ({ isDesktop }) => {
    const { actionData, actionTicket } = useSelector((state) => state.creditBills);
    const hasMoreThan1Bill = actionData?.invoiceList?.length > 1;
    const [showInfoText, setShowInfoText] = useState(true);

    useConfirmTransaction(actionData, actionTicket, `creditBills/transmission`);
    return (
        <>
            <Notification scopeToShow="transmitFCEMSummaryPage" />
            <ResponsiveHeader id="creditBill.transmit" showLabel />
            <MainContainer className="credit-bills">
                <h2>{i18n.get("afip.payment.confirm")}</h2>
                <div className="box box-border-soft">
                    <GridTable>
                        <GridTable.Container columns={isDesktop ? 3 : 1}>
                            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1}>
                                <CustomData
                                    titleText="creditBill.transmissionType.label"
                                    titleTextType="I18N"
                                    valueText={`creditBill.transmit.type.${actionData.transmissionType}`}
                                    valueTextType="I18N"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                columnWidth={1}
                                rowStart={isDesktop ? 1 : 2}>
                                <CustomData
                                    titleText="creditBill.beneficiaryType.label"
                                    titleTextType="I18N"
                                    valueText={`creditBill.beneficiary.type.${actionData.beneficiaryType}`}
                                    valueTextType="I18N"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                columnWidth={1}
                                rowStart={isDesktop ? 1 : 3}>
                                <CustomData
                                    titleText="creditBill.beneficiaryNumber.label"
                                    titleTextType="I18N"
                                    valueText={actionData.cuit}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={1}
                                columnWidth={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 2 : 4}
                                className="credit-bills-recipt-devider">
                                <div className="credit-bills-divider" />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} columnWidth={1} rowStart={isDesktop ? 3 : 5}>
                                <CustomData
                                    titleText="creditBill.cuit.label"
                                    titleTextType="I18N"
                                    valueText={actionData.beneficiaryCompanyName}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                columnWidth={1}
                                rowStart={isDesktop ? 3 : 6}>
                                <CustomData
                                    titleText="creditBill.transmission.motive.label"
                                    titleTextType="I18N"
                                    valueText={actionData.motive}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                </div>
                {hasMoreThan1Bill && (
                    <div className="credit-bills-sumary-modal">
                        <BillInfoSummary bills={actionData?.invoiceList} isSummaryPage isDesktop={isDesktop} />
                    </div>
                )}
                <div className="credit-bills-sumary-table">
                    <ActionBillTable
                        isDesktop={isDesktop}
                        tabOption={actionData.tabOption}
                        bills={actionData.invoiceList}
                        hideButton
                        summary
                    />
                </div>

                {showInfoText && (
                    <div className="credit-bills-sumary-note">
                        <CustomData
                            icon="images/information_fill.svg"
                            titleText="creditBill.transmit.indications"
                            titleTextType="I18N"
                        />
                        <CustomButton
                            icon="images/figma/icon/cross.svg"
                            func={() => setShowInfoText(false)}
                            lassName="toolbar-item"
                        />
                    </div>
                )}
                <GeneralCredentialForm
                    transactionData={actionData}
                    action={creditBillActions.transmitBill}
                    idActivity="fcem.action"
                    signData={["action"]}
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

TransmitFCEMSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransmitFCEMSummaryPage;
